import React from 'react'
import { FormHelperText } from '@mui/material'
import { CustomInput } from '../../../components/custom-input/CustomInput'

interface UserInfoProps {
    name: string
    setName: (value: string) => void
    phone: string
    setPhone: (value: string) => void
    errorState: { name: boolean; phone: boolean }
    t: (key: string) => string
}

const UserInfo: React.FC<UserInfoProps> = ({ name, setName, phone, setPhone, errorState, t }) => (
  <div className="checkout-page__container-contact">
    <div className="checkout-page__container-contact-input">
      <CustomInput
        label={t('NAME')}
        error={!errorState.name}
        value={name}
        fullWidth
        variant="filled"
        size="small"
        onChange={(e) => setName(e.target.value)}
      />
      {!errorState.name && (
        <FormHelperText error id="component-error-text">
          {t('FIELD_REQUIRED')}
        </FormHelperText>
      )}
    </div>
    <div className="checkout-page__container-contact-input">
      <CustomInput
        label={t('PHONE')}
        type="tel"
        error={!errorState.phone}
        value={phone}
        fullWidth
        variant="filled"
        size="small"
        onChange={(e) => setPhone(e.target.value)}
      />
      {!errorState.phone && (
        <FormHelperText error id="component-error-text">
          {t('FIELD_REQUIRED')}
        </FormHelperText>
      )}
    </div>
  </div>
)

export default UserInfo